import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "components/ui/input";
import { cn } from "lib/utils";

/* eslint-disable react/prop-types -- mirrors the plain-JS shadcn UI components. */
function PasswordInput({ className, toggleClassName, ...props }) {
  const [showPassword, setShowPassword] = useState(false);
  const toggleLabel = showPassword ? "Hide password" : "Show password";

  return (
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        className={cn("pr-10", className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShowPassword((show) => !show)}
        className={cn(
          "absolute inset-y-0 right-3 flex cursor-pointer items-center text-muted-foreground hover:text-foreground",
          toggleClassName
        )}
        aria-label={toggleLabel}
      >
        {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
/* eslint-enable react/prop-types */

export { PasswordInput };
